import React from 'react';
import { Courier } from '@/shared/types/couriers';
import styles from './CourierDetailsModal.module.css';

interface CourierDetailsModalProps {
    isOpen: boolean;
    onClose: () => void;
    courier: Courier | null;
}

export const CourierDetailsModal: React.FC<CourierDetailsModalProps> = ({ isOpen, onClose, courier }) => {
    if (!isOpen || !courier) return null;

    const isMotorized = courier.vehicle.type === 'moto' || courier.vehicle.type === 'carro';

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h2>Detalles del Repartidor</h2>
                    <button className={styles.closeBtn} onClick={onClose}>&times;</button>
                </div>

                <div className={styles.content}>
                    <div className={styles.profileHeader}>
                        <img
                            src={courier.photoUrl || 'https://via.placeholder.com/150'}
                            alt={courier.fullName}
                            className={styles.avatar}
                        />
                        <div className={styles.profileInfo}>
                            <h4>{courier.fullName}</h4>
                            <span className={`${styles.statusBadge} ${styles[`status_${courier.status}`]}`}>
                                {courier.status}
                            </span>
                        </div>
                    </div>

                    <section className={styles.section}>
                        <h3>Información de Contacto</h3>
                        <div className={styles.infoGrid}>
                            <div><strong>Email:</strong> {courier.email}</div>
                            <div><strong>Teléfono:</strong> {courier.phone}</div>
                        </div>
                    </section>

                    <section className={styles.section}>
                        <h3>Vehículo</h3>
                        <div className={styles.infoGrid}>
                            <div><strong>Tipo:</strong> {courier.vehicle.type}</div>
                            <div><strong>Marca:</strong> {courier.vehicle.brand || 'N/A'}</div>
                            <div><strong>Placa:</strong> {courier.vehicle.plate || 'N/A'}</div>
                        </div>
                        {courier.vehicle.photoUrl && (
                            <div className={styles.imageBox}>
                                <strong>Foto del Vehículo:</strong>
                                <img src={courier.vehicle.photoUrl} alt="Vehículo" className={styles.previewImage} />
                            </div>
                        )}
                    </section>

                    <section className={styles.section}>
                        <h3>Documentos de Verificación</h3>
                        <div className={styles.documentsGrid}>
                            {courier.documents?.idCardFront && (
                                <div className={styles.documentItem}>
                                    <span>Carnet (Frontal)</span>
                                    <img src={courier.documents.idCardFront} alt="ID Front" onClick={() => window.open(courier.documents?.idCardFront)} />
                                </div>
                            )}
                            {courier.documents?.idCardBack && (
                                <div className={styles.documentItem}>
                                    <span>Carnet (Reverso)</span>
                                    <img src={courier.documents.idCardBack} alt="ID Back" onClick={() => window.open(courier.documents?.idCardBack)} />
                                </div>
                            )}
                            {courier.documents?.propertyCard && (
                                <div className={styles.documentItem}>
                                    <span>Tarjeta Propiedad / RUAT</span>
                                    <img src={courier.documents.propertyCard} alt="Property Card" onClick={() => window.open(courier.documents?.propertyCard)} />
                                </div>
                            )}
                            {isMotorized && courier.documents?.soat && (
                                <div className={styles.documentItem}>
                                    <span>SOAT</span>
                                    <img src={courier.documents.soat} alt="SOAT" onClick={() => window.open(courier.documents?.soat)} />
                                </div>
                            )}
                            {isMotorized && courier.documents?.driverLicenseFront && (
                                <div className={styles.documentItem}>
                                    <span>Licencia (Frontal)</span>
                                    <img src={courier.documents.driverLicenseFront} alt="License Front" onClick={() => window.open(courier.documents?.driverLicenseFront)} />
                                </div>
                            )}
                            {isMotorized && courier.documents?.driverLicenseBack && (
                                <div className={styles.documentItem}>
                                    <span>Licencia (Reverso)</span>
                                    <img src={courier.documents.driverLicenseBack} alt="License Back" onClick={() => window.open(courier.documents?.driverLicenseBack)} />
                                </div>
                            )}
                            {isMotorized && courier.documents?.technicalReview && (
                                <div className={styles.documentItem}>
                                    <span>Revisión Técnica</span>
                                    <img src={courier.documents.technicalReview} alt="Technical Review" onClick={() => window.open(courier.documents?.technicalReview)} />
                                </div>
                            )}
                        </div>
                    </section>
                </div>

                <div className={styles.footer}>
                    <button className={styles.btnSecondary} onClick={onClose}>Cerrar</button>
                </div>
            </div>
        </div>
    );
};
